/* globals Jet */

const config = Object.assign({
    locales: [],
    current: null,
    default: null,
    active: []
}, Jet.translations);

var Lang = require('lang.js');
const packageLang = new Lang();

let $lang = {
    isActive,
    isCurrent,
    toggle,
    all: config.locales,
    _current: config.current,
    get current() {
        return this._current;
    },
    get prefix() {
        if (this._current === 'en') {
            return '';
        }
        return this._current;
    },
    set current(lang) {
        if (!this.all.includes(lang)) {
            return;
        }
        if (this.active.length === 1 && this.active[0] === this._current) {
            this.active = [lang];
        }
        this._current = lang;

        packageLang.setLocale(lang);
    },
    default: Jet.translations.locale,
    active: [Jet.translations.current],
    setTranslation(...args) {
        packageLang.setMessages(...args);
    },
    translate(...args) {
        return packageLang.get(...args);
    }
};

function toggle(lang) {
    if (!this.all.includes(lang)) {
        return;
    }
    if (this.active.includes(lang)) {
        this.active = this.active.filter(x => x !== lang);
        if (this.active.length === 0) {
            this.active.push(this.current);
        }
    }
    else {
        this.active.push(lang);
    }
}

function isActive(lang) {
    return this.active.includes(lang);
}

function isCurrent(lang) {
    return lang == this._current;
}

export default {
    lang: $lang,
    install(Vue) {
        Vue.mixin({
            data() {
                return { $lang };
            }
        });
        Vue.prototype.$lang = $lang;
        Vue.filter('trans', (...args) => packageLang.get(...args));
    }
};


// WEBPACK FOOTER //
// ./resources/js/lang.js